import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { useTitular } from '../../../../contexts/InclusaoTitular/context';
import { useGlobal } from '../../../../contexts/Global/context';

import {
    getEnderecoByCep,
    getMunicipios,
    validaCpfDuplicidade,
    getCongenerByContractAndPlan,
    getCongenerByContractAndPlanAndUfAndCity,
    getStates,
    getCities,
} from '../../../../services';

import Button from '../../../../components/Button';
import Accordion from '../../../../components/Accordion';
import Input from '../../../../components/Inputs/Input';
import InputTag from '../../../../components/Inputs/InputTag';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Select from '../../../../components/Inputs/Select';
import StepProgress from '../../../../components/StepProgress';
import FormContainer from '../../../../components/FormContainer';
import Radio from '../../../../components/Inputs/Radio';

import schema from './schema';

import steps from '../../../../utils/steps.json';
import validate from '../../../../utils/validateForm';

import { cloneObject } from '../../../../utils';
import MensagensAlertas from '../Alertas';
import Modal from '../../../../components/Modal';
import validators from '../../../../utils/defaultValidators';

import { EmptyField } from '../../../../components/Inputs/styles';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

function Titular({ location: { cameFrom } }) {
    const history = useHistory();

    const { dataActiveContract, staticOptions } = useGlobal();

    const { setDataTitular, dataTitular, setFlow, alerts, setAlerts } = useTitular();

    const [showModal, setShowModal] = useState(false);
    const [modalFooter, setModalFooter] = useState(null);
    const [modalMessage, setModalMessage] = useState(null);
    const [congenerContract, setCongenerContract] = useState([]);

    const [dataForm, setDataForm] = useState(dataTitular.cpf ? cloneObject(dataTitular) : cloneObject(schema));
    const [cepLoading, setCepLoading] = useState(false);
    const [alreadySearchedCep, setAlreadySearchedCep] = useState(!!dataForm.cep.unmaskedValue);

    const [dateStartPlanEdited, setDateStartPlanEdited] = useState(false);
    const [sugestedDateStartPlan, setSugestedDateStartPlan] = useState(false);

    const [loadingStepForward, setLoadingStepForward] = useState(false);
    const [adressAux, setadressAux] = useState(false);

    function mapStateOptions(results) {
        return results.map(({ descricaoUf, idUf }) => ({
            codigo: idUf,
            nome: descricaoUf,
        }));
    }

    function mapCityOptions(results) {
        return results.map(({ descricaoMunicipio, idMunicipio }) => ({
            codigo: idMunicipio,
            nome: descricaoMunicipio,
        }));
    }

    async function getCongenereStates(numeroContrato, codigoPlano) {
        const { results } = await getCongenerByContractAndPlan({ numeroContrato, codigoPlano });
        setCongenerContract(results);

        const states = new Set();

        await Promise.all(
            results.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getStates({ idContratoCongenere: numeroContratoCongenere });
                if (congenere?.estados) {
                    congenere.estados.forEach((estado) => {
                        states.add(JSON.stringify(estado));
                    });
                }
            })
        );
        return Array.from(states)
            .map((state) => JSON.parse(state))
            .flat();
    }

    async function getCongenereCities(idUf) {
        if (!congenerContract) return [];

        const cities = new Set();

        await Promise.all(
            congenerContract.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getCities({ idContratoCongenere: numeroContratoCongenere, idUf });

                if (congenere?.municipios) {
                    congenere.municipios.forEach((municipio) => {
                        cities.add(JSON.stringify(municipio));
                    });
                }
            })
        );
        return Array.from(cities)
            .map((city) => JSON.parse(city))
            .flat();
    }

    async function loadDataContrato() {
        const { isHealth, isPme, healthDeclarationRequired, referenciaMovimentacao } = dataActiveContract;

        const isPmeAndHealth = isPme && isHealth;

        let dataInclusao = dataForm.dateStartPlan.value;

        if (!dataForm.dateStartPlan.value && referenciaMovimentacao.dataInclusao) {
            dataInclusao = moment(referenciaMovimentacao.dataInclusao);
        }

        const initialValues = {
            ...dataForm,
            cellphone: {
                ...dataForm.cellphone,
                required: dataActiveContract.isAdesao || dataActiveContract.isPme,
            },
            email: {
                ...dataForm.email,
                required: dataActiveContract.isAdesao || dataActiveContract.isPme,
            },
            cid: {
                ...dataForm.cid,
                error: '',
            },
            company: {
                ...dataForm.company,
                options: [...dataActiveContract.empresas],
            },
            lackGroup: {
                ...dataForm.lackGroup,
                required:
                    dataActiveContract.isAdesao &&
                    (!dataActiveContract.parametros.tipoMovimentacaoCadastral === 'T' ||
                        !(
                            dataActiveContract.parametros.tipoMovimentacaoCadastral !== 'T' &&
                            dataActiveContract.parametros.possuiAutonomiaIsencaoCarencia
                        )),
                options: [],
            },
            healthPlan: { ...dataForm.healthPlan, options: [...dataActiveContract.planos] },
            functionalStatus: {
                ...dataForm.functionalStatus,
                options: [...staticOptions.situacaoEmpresa],
            },
            capacity: {
                ...dataForm.capacity,
                required: dataActiveContract.obrigaInformarLotacao,
                options: [...dataActiveContract.lotacoes],
                error: '',
            },
            startCapacity: {
                ...dataForm.startCapacity,
                required: dataActiveContract.obrigaInformarLotacao,
                error: '',
            },
            costCenter: {
                ...dataForm.costCenter,
                lookup: dataActiveContract.centrosCusto.find((option) => +dataForm.costCenter.value === +option.codigo)
                    ?.nome,
                options: [...dataActiveContract.centrosCusto],
            },
            uf: { ...dataForm.uf, options: [...staticOptions.estados] },
            civilState: {
                ...dataForm.civilState,
                options: [...staticOptions.estadoCivil],
            },
            dateStartPlan: {
                ...dataForm.dateStartPlan,
                value: dataInclusao,
                disabled: (dataActiveContract.isPj || dataActiveContract.isLicitacao) && dataInclusao,
            },
            contractSize: {
                ...dataForm.contractSize,
                value: dataActiveContract.regraEmpresa.porte,
            },
            contractType: {
                ...dataForm.contractType,
                value: dataActiveContract.tipoProduto.codigo,
            },
            occupation: {
                ...dataForm.occupation,
                required: dataActiveContract.isPj,
                lookup: dataActiveContract.funcoes.find((option) => +dataForm.occupation.value === +option.codigo)
                    ?.nome,
                options: [...dataActiveContract.funcoes],
                error: '',
            },
            functionalEnrollment: {
                ...dataForm.functionalEnrollment,
                required: !isPmeAndHealth,
                error: '',
            },
            enrollmentSequence: {
                ...dataForm.enrollmentSequence,
                required: !isPmeAndHealth,
                error: '',
            },
            height: {
                ...dataForm.height,
                required: isHealth && healthDeclarationRequired,
                error: '',
            },
            weight: {
                ...dataForm.weight,
                required: isHealth && healthDeclarationRequired,
                error: '',
            },
        };

        if (referenciaMovimentacao.dataInclusao) {
            if (
                !!initialValues.dateStartPlan.value &&
                moment(initialValues.dateStartPlan.value).format('DD-MM-YYYY') !==
                    moment(referenciaMovimentacao.dataInclusao).format('DD-MM-YYYY')
            ) {
                setDateStartPlanEdited(true);
            }

            setSugestedDateStartPlan(moment(referenciaMovimentacao.dataInclusao).toISOString());
        }

        setDataForm({
            ...dataForm,
            ...initialValues,
        });
    }

    async function handleChangeCep(event) {
        const { value, unmaskedValue } = event;

        setCepLoading(true);
        let foundCep = true;
        const response = await getEnderecoByCep(unmaskedValue);

        // Para zerar o endereço caso seja digitado um cep inválido
        if (!response) {
            setadressAux(true);
            foundCep = false;
        }

        const address = response;

        const dataAddress = {
            address: {
                ...dataForm.address,
                value: address.tipoLogradouro ? `${address?.tipoLogradouro}. ${address?.logradouro}` : '',
            },
            hood: { ...dataForm.hood, value: address ? address?.estado?.municipios[0].bairros[0].nome : '' },
            uf: {
                ...dataForm.uf,
                value: address ? address?.estado?.sigla : '',
                lookup: address ? address?.estado?.nome : '',
            },
            city: {
                ...dataForm.city,
                value: address ? address?.estado?.municipios[0].codigo : '',
                lookup: address ? address?.estado?.municipios[0].nome : '',
            },
            cep: {
                ...dataForm.cep,
                unmaskedValue,
                value,
                error: !foundCep && 'Os dados de endereço não foram localizados a partir do CEP informado',
            },
        };

        if (foundCep) {
            dataAddress.address.error = '';
            dataAddress.hood.error = '';
            dataAddress.uf.error = '';
            dataAddress.city.error = '';
        }

        setCepLoading(false);
        setAlreadySearchedCep(true);

        return adressAux ? false : dataAddress;
    }

    async function handleModalsRules(event) {
        const { id, value } = event;

        if (id === 'dateStartPlan' && sugestedDateStartPlan) {
            if (!!value && moment(value).format('DD-MM-YYYY') !== moment(sugestedDateStartPlan).format('DD-MM-YYYY')) {
                if (!dateStartPlanEdited) {
                    setModalMessage(
                        'A vigência indicada está de acordo com o período de cobertura da empresa e, caso seja alterada, poderá acarretar cobrança retroativa do valor integral da mensalidade do beneficiário.'
                    );
                    setModalFooter('dateStartPlan');
                    setShowModal(true);
                }
            } else {
                const newAlerts = alerts.filter((alert) => alert.codigo !== 'dateStartPlan');

                setDateStartPlanEdited(false);

                setAlerts([...newAlerts]);
            }
        }
    }

    function handleInputBlur(event) {
        if (showModal) return;

        const { id, name, value } = event.target;
        const key = id || name;
        const form = cloneObject(dataForm);

        if (key === 'dateStartPlan') {
            form.birth.error = '';
            form.admissionDate.error = '';

            if (form.birth.value) validators.birth(form);
            if (form.admissionDate.value) validators.admissionDate(form);
        }

        if (key === 'admissionDate') {
            form.dateStartPlan.error = '';
            form.birth.error = '';

            if (form.dateStartPlan.value) validators.dateStartPlan(form);
            if (form.birth.value) validators.birth(form);
        }

        if (key === 'birth') {
            form.dateStartPlan.error = '';
            form.admissionDate.error = '';
            form.dn.error = '';

            if (form.admissionDate.value) validators.admissionDate(form);
            if (form.dateStartPlan.value) validators.dateStartPlan(form);
            if (form.dn.value) validators.dn(form);
        }

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeState(state) {
        let municipios = [];

        if (state) municipios = (await getMunicipios(state)) || [];

        return municipios;
    }

    async function updateCongenerName() {
        const stateService = cloneObject(dataForm.stateService)?.value;
        const countyService = cloneObject(dataForm.countyService)?.value;
        const healthPlan = cloneObject(dataForm.healthPlan)?.value;

        const congenerName = cloneObject(dataForm.congenerName);

        if (!stateService || !countyService || !healthPlan) {
            setDataForm((current) => ({ ...current, congenerName: { ...congenerName, value: '' } }));
            return;
        }

        const { results } = await getCongenerByContractAndPlanAndUfAndCity({
            numeroContrato: dataActiveContract?.numero,
            codigoPlano: dataForm?.healthPlan.value,
            siglaUf: dataForm?.stateService.value,
            codigoMunicipio: dataForm?.countyService.value,
        });

        congenerName.value = results[0]?.nomeFantasiaCongenere || '';

        setDataForm((current) => ({ ...current, congenerName }));
    }

    useEffect(() => {
        updateCongenerName();
    }, [dataForm.stateService.value, dataForm.countyService.value, dataForm.healthPlan.value]);

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        let field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest,
        };

        handleModalsRules(event);

        const countyService = cloneObject(dataForm.countyService);

        if (id === 'stateService') {
            const municipios = await getCongenereCities(value);

            countyService.options = mapCityOptions(municipios);
            countyService.value = '';
            countyService.lookup = '';
        }

        const city = cloneObject(dataForm.city);

        if (id === 'uf') {
            const municipios = value ? await handleChangeState(value) : [];

            city.options = municipios;
            city.value = '';
            city.lookup = '';
        }

        let dataAddress = {};

        if (id === 'cep' && unmaskedValue.length === 8 && unmaskedValue !== dataForm.cep.value) {
            dataAddress = (await handleChangeCep(event)) || {};

            if (dataAddress.uf.value) {
                document.getElementById('addressNumber').focus();
            }

            const municipios = await handleChangeState(dataAddress.uf.value);

            dataAddress.city.options = municipios;

            field = dataAddress.cep;
        }

        const lackGroup = cloneObject(dataForm.lackGroup);

        const stateService = cloneObject(dataForm.stateService);

        if (id === 'healthPlan') {
            const congenerStates = await getCongenereStates(dataActiveContract.numero, value);

            stateService.options = mapStateOptions(congenerStates) || [];

            countyService.value = '';
            countyService.error = '';
            stateService.value = '';
            stateService.error = '';

            if (!value) {
                lackGroup.error = '';
                lackGroup.value = '';
            }

            if (field.gruposCarencias?.titular?.length > 0) {
                lackGroup.options = field.gruposCarencias.titular;
            }
        }

        setDataForm({
            ...dataForm,
            countyService,
            stateService,
            city,
            lackGroup,
            ...dataAddress,
            [id]: field,
        });
    }

    async function handleFowardStep() {
        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (isValid) {
            // Entao valida duplicidade de CPF
            const payload = {
                numContrato: dataActiveContract.numero,
                codigoPlano: dataForm.healthPlan.value,
                dtNascimento: dataForm.birth.value,
                cpf: dataForm.cpf.unmaskedValue,
                nome: dataForm.fullName.value,
                situacao: dataActiveContract.situacaoAtual === 'A' ? 'ATIVO' : 'INATIVO',
            };

            setLoadingStepForward(true);

            const { cpfExistente } = (await validaCpfDuplicidade(payload)) || {};

            setLoadingStepForward(false);

            if (cpfExistente) {
                setModalMessage('Este CPF já está cadastrado no sistema. Adicione outro para o novo beneficiário.');

                setShowModal(true);

                setModalFooter('cpfExistente');

                return;
            }

            setDataTitular({
                ...validatedForm,
            });

            history.push('/movimentacao_cadastral/adicionar_dependente');
        } else {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 300);
        }
    }

    function ModalMessage({ footer }) {
        return (
            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showModal}
                closable={false}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {footer === 'dateStartPlan' && (
                    <>
                        <Button
                            type="secondary"
                            onClick={() => {
                                setDataForm({
                                    ...dataForm,
                                    dateStartPlan: {
                                        ...cloneObject({
                                            ...dataForm.dateStartPlan,
                                            value: sugestedDateStartPlan,
                                        }),
                                    },
                                });
                                setShowModal(false);
                            }}
                        >
                            Não quero
                        </Button>

                        <Button
                            type="primary"
                            onClick={() => {
                                setAlerts([
                                    ...alerts,
                                    {
                                        tipo: 2,
                                        codigo: 'dateStartPlan',
                                        descricao: '',
                                        complemento:
                                            'Você está alterando a data de início do plano. Com essa mudança o valor da próxima fatura terá novos custos.',
                                    },
                                ]);
                                setShowModal(false);
                                setDateStartPlanEdited(true);
                            }}
                        >
                            Quero Alterar
                        </Button>
                    </>
                )}

                {footer === 'contratoInadimplente' && (
                    <Button type="primary" onClick={() => setShowModal(false)}>
                        OK
                    </Button>
                )}

                {footer === 'cpfExistente' && (
                    <Button type="primary" onClick={() => setShowModal(false)}>
                        Revisar
                    </Button>
                )}
            </Modal>
        );
    }

    useEffect(() => {
        setFlow('adicionar_titular');

        if (!dataTitular.cpf || cameFrom === 'movimentacoes_pendentes') loadDataContrato();
    }, []);

    return (
        <PageContainer>
            <StepProgress steps={steps.inclusaoTitular} activeStep={1} />

            <MensagensAlertas />

            <Accordion title="Dados para o plano">
                <FormContainer>
                    <Select field={dataForm.company} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.healthPlan} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui
                        field={dataForm.dateStartPlan}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Select field={dataForm.stateService} onBlur={handleInputBlur} onChange={handleChangeInput} />

                    {dataActiveContract.isAdesao && (
                        <Input
                            field={{ ...dataForm.lackGroup, disabled: !dataForm.healthPlan.value }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    )}

                    <Select
                        field={{
                            ...dataForm.countyService,
                            disabled: !dataForm.stateService.value && !dataForm.countyService.value,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />

                    {dataForm.congenerName.value !== '' ? <Input field={dataForm.congenerName} /> : null}
                </FormContainer>
            </Accordion>

            <Accordion title="Dados profissionais">
                <FormContainer>
                    <Select field={dataForm.occupation} onBlur={handleInputBlur} onChange={handleChangeInput} />

                    <EmptyField />

                    <Select field={dataForm.functionalStatus} onBlur={handleInputBlur} onChange={handleChangeInput} />

                    <DatepickerMui
                        field={dataForm.admissionDate}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input
                        field={dataForm.functionalEnrollment}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input field={dataForm.enrollmentSequence} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui
                        field={dataForm.startCapacity}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />

                    <Select field={dataForm.capacity} onBlur={handleInputBlur} onChange={handleChangeInput} />

                    {dataActiveContract.isPj && (
                        <Select field={dataForm.costCenter} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    )}

                    <DatepickerMui field={dataForm.startDate} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>

            <Accordion title="Dados de titular">
                <FormContainer>
                    <Input field={dataForm.cpf} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Radio field={dataForm.nationality} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.fullName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.socialName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui field={dataForm.birth} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.gender} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.motherName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.civilState} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.pis} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.sus} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.dn} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>

            <Accordion title="Dados de contato">
                <FormContainer>
                    <Input
                        field={{
                            ...dataForm.cep,
                            disabled: cepLoading,
                            loading: cepLoading,
                            icon: { name: 'search', type: 'round' },
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <EmptyField />
                    <Input
                        field={{
                            ...dataForm.address,
                            disabled: !alreadySearchedCep,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input field={dataForm.addressNumber} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.complement} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input
                        field={{
                            ...dataForm.hood,
                            disabled: !alreadySearchedCep,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Select
                        field={{
                            ...dataForm.uf,
                            disabled: !alreadySearchedCep,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Select
                        field={{
                            ...dataForm.city,
                            disabled: !alreadySearchedCep,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input field={dataForm.cellphone} onBlur={handleInputBlur} onChange={handleChangeInput} />

                    <Input field={dataForm.email} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>
            {((dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired) ||
                dataActiveContract.isAdesao ||
                dataActiveContract.isPme) && (
                <Accordion title="Dados de saúde">
                    <FormContainer>
                        {dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired && (
                            <>
                                <Input field={dataForm.weight} onBlur={handleInputBlur} onChange={handleChangeInput} />
                                <Input field={dataForm.height} onBlur={handleInputBlur} onChange={handleChangeInput} />
                            </>
                        )}
                        {(dataActiveContract.isPme || dataActiveContract.isAdesao) && (
                            <InputTag field={dataForm.cid} onBlur={handleInputBlur} onChange={handleChangeInput} />
                        )}
                    </FormContainer>
                </Accordion>
            )}

            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingStepForward}
                    disabled={loadingStepForward}
                    onClick={handleFowardStep}
                >
                    Continuar
                </Button>
            </ContainerButton>

            <ModalMessage footer={modalFooter} />
        </PageContainer>
    );
}

export default Titular;
